// extracted by mini-css-extract-plugin
export var skrillMethodIcon = "SkrillMethodIcon-module--skrillMethodIcon--51884";